import { render, staticRenderFns } from "./LoginProcessToken.vue?vue&type=template&id=33c3d114&"
import script from "./LoginProcessToken.vue?vue&type=script&lang=ts&"
export * from "./LoginProcessToken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports